import React, { useState, useRef, useEffect } from "react";
import { IconButton, Typography } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import Grid from "@mui/material/Grid2";
import { Link } from "react-router-dom";
import Footer from "../../Footer/Footer";
import Header from "../../Header/MegaMenu";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import "owl.carousel"; // Import Owl Carousel AFTER jQuery
import OwlCarousel from "react-owl-carousel";
import '../outterpages.css'
import curreciesBan from '../../../assets/Images/Outterpage/currencies-banner-img.webp';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from "@mui/material/styles";
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';
import Stack from '@mui/material/Stack';
import eng from '../../../assets/Images/Outterpage/eng.webp'
import jap from '../../../assets/Images/Outterpage/jap.webp'
import cardimg from '../../../assets/Images/Outterpage/card-1.webp'
import sec4 from '../../../assets/Images/Outterpage/sec-4-img.webp'
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import cryptobann from '../../../assets/Images/Outterpage/crypto-banner.webp'

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    borderBottom: "1px solid  rgba(255, 146, 71, 1)  ",
    '&:nth-of-type(odd)': {
        background: "linear-gradient(90deg,rgba(99, 97, 97, 0.44) 15.1%,rgba(70, 69, 68, 0.49) 85.42%)",
    },
    // Hide the last border of the table
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

// const videos = [
//   { id: 1, src: video1 },
//   { id: 2, src: video2 },
//   { id: 3, src: video3 },
//   { id: 3, src: video4 },
// ];
const testimonials = [
    {
        name: "Sherly",
        position: "CEO",
        text: "Figma ipsum component variant main layer. Library figjam subtract font rotate move auto. Figjam strikethrough bullet text device pen scale. Group horizontal link library flows ellipse flatten library undo.",
    },
    {
        name: "Carlos",
        position: "Product Manager",
        text: "An amazing experience! The support and innovation mindset Rishi brings to the team makes every project more exciting and successful.",
    },
    // {
    //   name: "Rishi",
    //   position: "CEO",
    //   text: "Regulus has truly streamlined my trading activity. The platform is incredibly user-friendly, making it easy to navigate and execute trades quickly. I've seen a noticeable improvement in my efficiency!",
    // },
];

const options = {
    margin: 50,
    items: 1,
    autoplay: true,
    autoplayTimeout: 6000,
    dots: false, // Hide default dots
    loop: true,
    smartSpeed: 800,
    nav: true, // We will use custom navigation
    responsive: {
        0: {
            dots: true,
            nav: false,
        },
        768: {
            dots: false,
            nav: true,
        },
    },
};

const marketData = [
    { id: 1, pair: "GBP/USD", value: "1,355.78", trend: "up" },
    { id: 2, pair: "GBP/USD", value: "1,120.65", trend: "down" },
    { id: 3, pair: "GBP/USD", value: "1,120.65", trend: "down" },
    { id: 4, pair: "GBP/USD", value: "1,355.78", trend: "up" },
    { id: 5, pair: "GBP/USD", value: "1,120.65", trend: "down" },
];


const tableData = [
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },

]
const accordianData = [
    {
        question: "How Does Copy Trading Work?",
        answer: "Copy trading enables users to automatically replicate trades made by experienced traders. When a selected trader executes a trade, it is mirrored in the follower's account, reflecting the same actions in real-time.",
        panel: "panel1"
    },
    {
        question: "Is Copy Trading Suitable for Beginners?",
        answer: "Yes, copy trading can be advantageous for beginners by enabling them to learn from expert strategies and potentially earn while gaining market insights. However, it's important to understand the associated risks.",
        panel: "panel2"
    },
   
]

const CryptoCurrencies = () => {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const lg = useMediaQuery(theme.breakpoints.up("lg"));
    const md900 = useMediaQuery(theme.breakpoints.up("900"));
    const xl = useMediaQuery(theme.breakpoints.up("xl"));
    const [expanded, setExpanded] = React.useState('panel1');

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };
    return (
        <div className="OutterPage">
            <Header />
            <div className="bg-outer">
                <section className="banner outter-banner">
                    <div className="contain-width">
                        <Grid container sx={{ alignItems: "flexStart" }}>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }} sx={{ placeContent: "center" }}>
                                <div
                                    className="banner-left "
                                    style={{ height: xl ? "500px" : "auto", placeContent: "center" }}
                                >
                                    <p>Copy Trading</p>
                                    <h1 className="mb-30 mt-10">
                                        Trade Smarter with <span> Finowiz </span> Copy Trading
                                    </h1>
                                    <p>TradEnhance your trading strategy with Finowiz's Copy Trading feature. Easily replicate successful trades and adopt effective strategies from experienced traders to optimize your trading performance.e commodities such as metals and energies to explore new market opportunities, protect against inflation, and diversify your investment portfolio effortlessly with Finowiz.</p>
                                    {/* <div
                  className="display-1 btn flex-wrap "
                  style={{ marginBottom: matches ? "40px" : "20px" }}
                >
                  <Link to="/open-new-account" className="bg-btn">
                    Get Started
                  </Link>
                </div> */}
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>

                                <div className="text-center ban-img cryt-ban">
                                    <img width="90%" src={cryptobann} />
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </section>
            
                <section className="trade-easy sec-3">
                    <div className="contain-width">
                        <div className="heading">
                            {/* <p>
                                <span>Why Finowiz</span>
                            </p> */}
                            <h2>
                                Our Unique <span>Benefits </span>
                            </h2>
                            <p>
                                Enjoy exclusive copy trading features with Finowiz for a superior trading experience.
                            </p>
                        </div>
                        <Grid container spacing={5} >
                            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }} className="why-choose-card mt-10" sx={{ alignItems: !md900 && "center" }}>
                                <div>
                                    <img src={cardimg} />
                                </div>
                                <p className="mt-10 head"><span className="grd">Automated Replication</span></p>
                                <p className="mt-10">Effortlessly mirror trades from experienced traders in real-time.</p>

                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }} className="why-choose-card mt-10" sx={{ alignItems: !md900 && "center" }}>
                                <div>
                                    <img src={cardimg} />
                                </div>
                                <p className="mt-10 head"><span className="grd">Performance Monitoring</span></p>
                                <p className="mt-10">Track and analyze the performance of copied trades to make informed decisions.</p>

                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }} className="why-choose-card mt-10" sx={{ alignItems: !md900 && "center" }}>
                                <div >
                                    <img src={cardimg} />
                                </div>
                                <p className="mt-10 head"><span className="grd" >Varied Trader Selection</span></p>
                                <p className="mt-10">Explore a diverse range of expert traders and strategies to suit your investment goals.</p>

                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }} className="why-choose-card mt-10" sx={{ alignItems: !md900 && "center" }}>
                                <div>
                                    <img src={cardimg} />
                                </div>
                                <p className="mt-10 head"><span className="grd">Flexible Control</span></p>
                                <p className="mt-10">Maintain control over your copied trades, with the ability to adjust or stop copying as needed.</p>

                            </Grid>

                        </Grid>


                    </div>
                </section>
            </div>

        
            <section class="cta-sec2 out-cta">
                <div className="contain-width">
                    <Grid container spacing={8}>
                        <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                            <label>Your Partner in Trading Success</label>
                            <h2 >Register Now for Seamless Trading with Finowiz</h2>
                            {/* <p>
                            Learn to trade without using real money, refining your
                            strategies and learning from mistakes.
                          </p> */}
                            <Link to="#" className="brd-btn" >
                                Register Now
                            </Link>
                        </Grid>
                    </Grid>
                </div>
            </section>



            <Footer />
        </div>
    );
};

export default CryptoCurrencies;
